<template>
  <div class="basic_wrap">
    <div class="page_header">
      <div class="header_inner">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">卡密信息</div>
      </div>
    </div>

    <div class="content_box">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length === 0 ? '' : '没有更多了'"
          @load="onLoad"
        >
          <van-empty v-if="!loading && list.length === 0" description="暂无卡密信息" />

          <div v-for="item in list" :key="item.id" class="kami_card">
            <div class="card_head">
              <p class="item_title van-multi-ellipsis--l2">{{ item.item_title || '商品名称' }}</p>
              <div class="head_btns">
                <van-icon
                  v-if="item.categoryName || item.cardTypeName || item.faceValue"
                  name="info-o"
                  class="info_icon"
                  @click="showMeta(item)"
                />
                <div v-if="item.cardText" class="copy_all_btn" @click="copyText(item.cardText)">一键复制</div>
              </div>
            </div>

            <div v-if="item.cardNo" class="secret_line">{{ item.cardNo }}</div>
            <div v-if="item.cardPwd" class="secret_line">{{ item.cardPwd }}</div>
            <div v-if="item.cardText && (item.isVerified || item.orderStatus === 3)" class="order_done_tag">订单已完成</div>
            <div v-if="item.createTime" class="time_line">
              <span>下单时间</span>
              <span>{{ item.createTime }}</span>
            </div>
            <div v-if="!item.cardNo && !item.cardPwd" class="empty_tip">
              {{ item.cardStatus === '已退款' ? '卡密发放失败，订单金额已退回余额' : '卡密发放中，预计24小时内自动到账，请耐心等待' }}
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-popup v-model="showMetaPopup" round class="meta_popup">
      <div class="popup_title">卡券信息</div>
      <div v-if="metaItem.categoryName" class="popup_row">
        <span>卡类</span>
        <span class="popup_value">{{ metaItem.categoryName }}</span>
      </div>
      <div v-if="metaItem.cardTypeName" class="popup_row">
        <span>卡种</span>
        <span class="popup_value">{{ metaItem.cardTypeName }}</span>
      </div>
      <div v-if="metaItem.faceValue" class="popup_row">
        <span>面值</span>
        <span class="popup_value">{{ metaItem.faceValue }}</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { List, PullRefresh, Empty, Popup, Icon } from 'vant';

Vue.use(List).use(PullRefresh).use(Empty).use(Popup).use(Icon);

export default {
  name: 'kamiInfo',
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pageSize: 10,
      showMetaPopup: false,
      metaItem: {},
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    pickValue(item, keys) {
      for (var i = 0; i < keys.length; i++) {
        var val = item[keys[i]];
        if (val !== undefined && val !== null && String(val).trim() !== '') {
          return String(val).trim();
        }
      }
      return '';
    },
    normalizeList(rows) {
      var result = [];
      for (var i = 0; i < rows.length; i++) {
        var item = rows[i] || {};
        if (parseInt(item.goods_type) !== 1) continue;
        // 支付失败订单没有卡密，跳过
        if (parseInt(item.status) === 4) continue;
        var cardNo = this.pickValue(item, ['card_no', 'card', 'kami', 'cardnum', 'kahao']);
        var cardPwd = this.pickValue(item, ['card_pwd', 'card_password', 'pwd', 'password', 'kamipwd', 'mima']);
        var cardText = [cardNo, cardPwd].filter(Boolean).join(' ');
        result.push({
          id: item.id,
          item_title: item.item_title || '',
          cardNo: cardNo,
          cardPwd: cardPwd,
          cardText: cardText,
          cardStatus: item.card_status || '',
          orderStatus: parseInt(item.status) || 0,
          createTime: item.create_time || '',
          categoryName: item.recycle_category_name || '',
          cardTypeName: item.recycle_card_type_name || '',
          faceValue: item.recycle_face_value || '',
          isVerified: parseInt(item.is_verified) === 1,
        });
      }
      return result;
    },
    onLoad() {
      Fetch('/shop/orders', {
        page: this.page,
        page_size: this.pageSize,
        goods_type: 1
      }).then((r) => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        var res = r.data || {};
        var current = this.normalizeList(res.list || []);
        this.list = this.list.concat(current);
        this.loading = false;

        if ((res.list || []).length < this.pageSize) {
          this.finished = true;
        } else {
          this.page++;
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      this.finished = false;
      this.page = 1;
      this.loading = true;
      this.onLoad();
    },
    showMeta(item) {
      this.metaItem = item || {};
      this.showMetaPopup = true;
    },
    copyText(text) {
      text = String(text || '');
      if (!text) {
        this.$toast('暂无可复制内容');
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(text);
        });
        return;
      }
      this.fallbackCopy(text);
    },
    fallbackCopy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast('复制成功');
    }
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-top: 60px;
  min-height: 100vh;
  background: #F3F3F5;
}
.page_header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  z-index: 20;
  background: url(../../assets/images/red_bg.png) no-repeat center center;
  background-size: 100% 100%;
}
.header_inner {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back_left {
  position: absolute;
  left: 0;
  top: 14px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: url(../images/item/back.png) no-repeat center center;
  background-size: auto 100%;
}
.big_tit {
  font-size: 17px;
  font-weight: 600;
  color: #FFFFFF;
}
.content_box {
  padding: 12px 10px 16px;
}
.kami_card {
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0px 2px 10px rgba(31, 35, 41, 0.08);
}
.card_head {
  min-height: 54px;
  padding: 12px 12px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(90deg, #5b8cff 0%, #7b67df 100%);
}
.item_title {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #FFFFFF;
  padding-right: 12px;
}
.copy_all_btn {
  flex-shrink: 0;
  min-width: 84px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.95);
  color: #6a61d8;
  font-size: 14px;
}
.head_btns {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.info_icon {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  color: #FFFFFF;
  font-size: 16px;
}
.secret_line {
  padding: 14px 12px 0;
  font-size: 16px;
  line-height: 24px;
  color: #1F2329;
  word-break: break-all;
}
.secret_line:last-of-type {
  padding-bottom: 14px;
}
.empty_tip {
  padding: 16px 12px;
  font-size: 14px;
  line-height: 22px;
  color: rgba(31, 35, 41, 0.55);
}
.order_done_tag {
  margin: 8px 12px 12px;
  padding: 6px 0;
  font-size: 13px;
  font-weight: 600;
  color: #18B566;
}
.time_line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding: 10px 12px;
  font-size: 12px;
  color: rgba(31, 35, 41, 0.45);
  border-top: 1px solid #F0F1F3;
}
.meta_popup {
  width: 78%;
  max-width: 340px;
  padding: 20px 18px 22px;
}
.popup_title {
  font-size: 17px;
  font-weight: 600;
  color: #1F2329;
  text-align: center;
  margin-bottom: 14px;
}
.popup_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 4px;
  font-size: 14px;
  &:not(:last-child) {
    border-bottom: 1px solid #F2F3F5;
  }
  & > span:first-child {
    color: rgba(31, 35, 41, 0.55);
  }
}
.popup_value {
  color: #1F2329;
  font-weight: 600;
}
</style>
